import Vue from 'vue';
import axios from 'axios';
import { bus } from '@/main';

if (process.env.NODE_ENV !== 'production') {
  axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'https://www.jobleadsdev.de/';
}
const withCredentialsDefault = true;
axios.defaults.withCredentials = withCredentialsDefault;

Object.assign(axios.defaults.headers, {
  Accept: 'application/json, text/plain, */*',
  'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  'X-Requested-With': 'XMLHttpRequest',
});

// @ts-ignore
const jwtToken = window.appSetup?.links?.api?.authorizationToken;
if (jwtToken) {
  Object.assign(axios.defaults.headers, {
    Authorization: `Bearer ${jwtToken}`,
  });
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // if unauthorized
    if (error.response?.status === 401) {
      console.warn('User not authorized. Logging out.');
      // invalid login credentials is an exception, we should not redirect user to login page in that case
      // @ts-ignore
      const loginFormUrl = window.appSetup?.links?.api?.user?.login;
      if (error.response?.config?.url === loginFormUrl) {
        return Promise.reject(error);
      }
      bus.$emit('user-unauthorized');
    }
    // if maintenance mode
    if (error.response?.status === 504 || error.response?.status === 503) {
      console.warn('Maintenance mode enabled');
      bus.$emit('maintenance-mode');
    }
    return Promise.reject(error);
  },
);

const api = {
  post(url, data = {}, ...atrs) {
    const formattedData = Object.entries(data)
      .filter(([, value]) => value !== undefined)
      .map(([key, value]) =>
        [key, encodeURIComponent(value !== null ? value.toString() : value)].join('='),
      )
      .join('&');
    return Object.getPrototypeOf(this).post(url, formattedData, ...atrs);
  },
  file(url, data) {
    return Object.getPrototypeOf(this).post(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  jsonPost(url, data) {
    return Object.getPrototypeOf(this).post(url, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },
  postForm(url, data = {}, ...atrs) {
    return Object.getPrototypeOf(this).post(url, data, ...atrs);
  },
  delete(url, data) {
    return Object.getPrototypeOf(this).delete(url, data);
  },
  getSetup(url) {
    // @ts-ignore
    const cacheBreaker = window.staticAppVersion || '';
    const originalHeaders = Object.assign({}, axios.defaults.headers);
    axios.defaults.withCredentials = false;
    delete axios.defaults.headers['X-Requested-With'];
    delete axios.defaults.headers['Authorization'];

    const res = Object.getPrototypeOf(this).get(
      url.includes('?') ? url + '&v=' + cacheBreaker : url + '?v=' + cacheBreaker,
    );

    axios.defaults.withCredentials = withCredentialsDefault;
    axios.defaults.headers = originalHeaders;
    return res;
  },
};
Object.setPrototypeOf(api, axios);

function plugin(app) {
  Object.assign(app.prototype, {
    $api: api,
  });
}

Vue.use(plugin);

export default api;
